module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.necessidades_especiais,
      "error-messages": _vm.necessidadeEspecialErros,
      "label": "Selecione uma Necessidade Especial",
      "item-text": "descricao",
      "item-value": "id",
      "single-line": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.necessidade.ref_necessidade_especial.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.necessidade.ref_necessidade_especial.$touch()
      }
    },
    model: {
      value: (_vm.data.necessidade.ref_necessidade_especial),
      callback: function($$v) {
        _vm.$set(_vm.data.necessidade, "ref_necessidade_especial", $$v)
      },
      expression: "data.necessidade.ref_necessidade_especial"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.necessidadeEspecialComplementoErros,
      "label": "Descrição"
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.necessidade.necessidade_especial_compl.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.necessidade.necessidade_especial_compl.$touch()
      }
    },
    model: {
      value: (_vm.data.necessidade.necessidade_especial_compl),
      callback: function($$v) {
        _vm.$set(_vm.data.necessidade, "necessidade_especial_compl", $$v)
      },
      expression: "data.necessidade.necessidade_especial_compl"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_vm._v("\n                Permanente?\n                "), _c('v-radio-group', {
    model: {
      value: (_vm.data.necessidade.fl_permanente),
      callback: function($$v) {
        _vm.$set(_vm.data.necessidade, "fl_permanente", $$v)
      },
      expression: "data.necessidade.fl_permanente"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Não",
      "color": "orange",
      "value": false
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Sim",
      "color": "orange",
      "value": true
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_vm._v("\n                Dificuldade ao acesso a alguns lugares?\n                "), _c('v-radio-group', {
    model: {
      value: (_vm.data.necessidade.fl_dificil_acesso),
      callback: function($$v) {
        _vm.$set(_vm.data.necessidade, "fl_dificil_acesso", $$v)
      },
      expression: "data.necessidade.fl_dificil_acesso"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Não",
      "color": "orange",
      "value": false
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Sim",
      "color": "orange",
      "value": true
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_vm._v("\n                Necessita acompanhamento?\n                "), _c('v-radio-group', {
    model: {
      value: (_vm.data.necessidade.fl_necessita_acompanhamento),
      callback: function($$v) {
        _vm.$set(_vm.data.necessidade, "fl_necessita_acompanhamento", $$v)
      },
      expression: "data.necessidade.fl_necessita_acompanhamento"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Não",
      "color": "orange",
      "value": false
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Sim",
      "color": "orange",
      "value": true
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": _vm.botaoClicado || _vm.$v.data.necessidade.$invalid
    },
    on: {
      "click": _vm.salvarNecessidadeEspecial
    }
  }, [_c('i', {
    staticClass: "fas fa-check"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Salvar Dados")])]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.limparNecessidadeEspecial
    }
  }, [_c('i', {
    staticClass: "fas fa-eraser"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Limpar")])])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('h3', {
    staticClass: "my-special-needs"
  }, [_vm._v("Necessidades Cadastradas")]), _vm._v(" "), _c('div', {
    staticClass: "responsive-table"
  }, [_c('table', {
    staticClass: "v-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Necessidade Especial")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("Permanente")]), _vm._v(" "), _c('th', [_vm._v("Dificuldade ao acesso a alguns lugares")]), _vm._v(" "), _c('th', [_vm._v("Necessita acompanhamento")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center",
      "width": "140"
    }
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.data.necessidades_especiais), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.necessidade_especial.descricao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.necessidade_especial_compl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.fl_permanente ? 'Sim' : 'Não'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.fl_dificil_acesso ? 'Sim' : 'Não'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.fl_necessita_acompanhamento ? 'Sim' : 'Não'))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "fab": "",
        "small": "",
        "depressed": "",
        "color": "info",
        "title": "Editar"
      },
      on: {
        "click": function($event) {
          return _vm.editarNecessidadeEspecial(item)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-edit"
    })]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "fab": "",
        "small": "",
        "depressed": "",
        "color": "error",
        "title": "Remover"
      },
      on: {
        "click": function($event) {
          return _vm.removerNecessidadeEspecial(item)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-times"
    })])], 1)])
  }), 0)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-559a836b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/pessoal/components/minha-conta/editar-meus-dados/NecessidadesEspeciais.vue
// module id = 544
// module chunks = 2